"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.confViewLoadCreator = void 0;
var consts_1 = require("../consts");
var confViewLoadCreator = function (event) {
    var eventData = {
        action: 'conf-view',
        event: 'conf-view-load',
        eventInfo: 'conf-view-load',
        conf: {
            confName: event.eventData.conf.confName || consts_1.NOT_AVAILABLE,
            confCat: event.eventData.conf.confCat || consts_1.NOT_AVAILABLE,
            confTags: event.eventData.conf.confTags || consts_1.NOT_AVAILABLE,
        },
        cart: {
            product: event.eventData.cart.product.map(function (item) { return (__assign(__assign({}, item), { bundledProduct: item.bundledProduct || consts_1.NOT_AVAILABLE })); }),
        },
    };
    return eventData;
};
exports.confViewLoadCreator = confViewLoadCreator;
